import { connect } from 'react-redux';
import RegistrationComponent from './UserRegistration';
import {
  getEmail,
  getEmailError,
  getConfirmEmail,
  getConfirmEmailError,
  getPassword,
  getPasswordError,
  getConfirmPassword,
  getConfirmPasswordError,
  getError,
  canSignup,
  isSigningUp,
  isSignedUp,
  shouldShowEmailError,
  shouldShowPasswordError,
  shouldShowConfirmEmailError,
  shouldShowConfirmPasswordError,
} from '../../../state/reducers/SignupReducer';
import SignupActions from '../../../state/actions/SignupActions';

const mapStateToProps = (state) => ({
  email: getEmail(state),
  emailError: shouldShowEmailError(state) ? getEmailError(state) : '',
  confirmEmail: getConfirmEmail(state),
  confirmEmailError: shouldShowConfirmEmailError(state)
    ? getConfirmEmailError(state)
    : '',
  password: getPassword(state),
  passwordError: shouldShowPasswordError(state) ? getPasswordError(state) : '',
  confirmPassword: getConfirmPassword(state),
  confirmPasswordError: shouldShowConfirmPasswordError(state)
    ? getConfirmPasswordError(state)
    : '',
  signupError: getError(state),
  canSignup: canSignup(state),
  isSigningUp: isSigningUp(state),
  isSignedUp: isSignedUp(state),
});

const {
  signupRequest,
  emailChanged,
  confirmEmailChanged,
  passwordChanged,
  confirmPasswordChanged,
} = SignupActions;

export default connect(mapStateToProps, {
  emailChanged,
  passwordChanged,
  confirmEmailChanged,
  confirmPasswordChanged,
  signup: signupRequest,
})(RegistrationComponent);



// WEBPACK FOOTER //
// ./src/view/forms/UserRegistration/index.js